import {IMeshCellValueFormat} from "@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ValueFormat";
import {MeshCellValueFormatKind} from "@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ValueFormatKind";
import {IValue} from "@mintdata/mint-kit/api/types/Value";
import {IMeshCellSettings} from "@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellSettings";

export class MeshCellMaskedTextValueFormat implements IMeshCellValueFormat
{
    static Default:MeshCellMaskedTextValueFormat = new MeshCellMaskedTextValueFormat(true);

    public readonly kind:MeshCellValueFormatKind = MeshCellValueFormatKind.MaskedText;
    public readonly masked:boolean;
    readonly id:string;

    public constructor(masked:boolean){
        this.masked = masked;
    }

    formatCode():string
    {
        return 'G';
    }

    readonly formatString: string;

    formatValue(value: IValue): string {
        if (this.masked)
            return '*********';

        return value ? value.toString() : '';
    }

    getTextColor(value: IValue, cellSettings: IMeshCellSettings): string {
        return "#000000";
    }

    digitsAfterPoint(): number {
        return 0;
    }

    isStringOfThisFormat(formattedValue:string):boolean
    {
        return false;
    }

    extractValue(formattedValue:string):any
    {
        return '*********'
    }
}
